import React from 'react'
import { makeStyles, Slider as MuiSlider, Typography } from '@material-ui/core'
import type { SliderProps as MuiSliderProps } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import type { StyleClasses } from '../../styles'

const useStyles = makeStyles<Theme, SliderProps>(
  (theme) => ({
    root: {
      color: theme.paintscout.palette.brand.Blue.Blue55,
      height: 8
    },
    thumb: {
      height: 16,
      width: 16,
      backgroundColor: theme.paintscout.palette.brand.Blue.Blue55,
      border: '2px solid #ffffff',
      marginTop: -2,
      boxShadow: '0 0 2px 1px rgba(0,0,0,0.5)',
      zIndex: 1000,
      '&:hover': {
        backgroundColor: theme.paintscout.palette.brand.Blue.Blue50,
        boxShadow: '0 0 2px 1px rgba(0,0,0,0.5)'
      }
    },
    active: {},
    valueLabel: {
      left: 'calc(-50% + 4px)'
    },
    track: {
      height: 12,
      borderRadius: 4
    },
    rail: {
      height: 12,
      borderRadius: 4,
      color: theme.paintscout.palette.brand.Neutral.P80
    },
    labelContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
      // marginLeft: `-${theme.spacing()}px`,
    }
  }),
  { name: 'Slider' }
)

export interface SliderProps extends Omit<MuiSliderProps, 'onChange'> {
  classes?: StyleClasses<typeof useStyles>
  label?: string
  progressLabel?: boolean
  onChange: (event: React.ChangeEvent<object>, value: number | number[]) => void
}

function Slider(props: SliderProps) {
  const classes = useStyles(props)
  const { label, progressLabel, ...muiSliderProps } = props

  return (
    <div>
      <div className={classes.labelContainer}>
        {label && <Typography variant="subtitle1">{label}</Typography>}
        {progressLabel && <Typography variant="body2">{`${muiSliderProps?.value ?? 0}%`}</Typography>}
      </div>
      <MuiSlider classes={classes} {...muiSliderProps} onChange={props.onChange} />
    </div>
  )
}

export default Slider
